import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0C0A]" data-testid="site-footer">
      <div className="page-container py-16 sm:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <Link to="/" className="inline-flex items-center gap-3" aria-label="Craftora home">
              <span className="w-9 h-9 rounded-[10px] bg-[#D8FF5B] text-[#11130F] flex items-center justify-center font-display font-bold" aria-hidden="true">C</span>
              <span className="font-display font-semibold text-2xl">Craftora</span>
            </Link>
            <h2 className="font-display text-3xl sm:text-4xl max-w-xl mt-8 leading-tight">Digital products with a sharper story and a stronger reason to act.</h2>
            <Link to="/booking" className="text-link mt-7" data-testid="footer-book-link">Book a discovery call <ArrowUpRight size={15} /></Link>
          </div>

          <div className="md:col-span-2 md:col-start-9">
            <p className="label-mono mb-4">Explore</p>
            <ul className="space-y-3 text-sm text-white/65">
              <li><Link to="/portfolio" className="link-underline">Selected work</Link></li>
              <li><Link to="/services" className="link-underline">Services</Link></li>
              <li><Link to="/booking" className="link-underline">Book a call</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="label-mono mb-4">Clients</p>
            <ul className="space-y-3 text-sm text-white/65">
              <li><Link to="/login" className="link-underline">Sign in</Link></li>
              <li><Link to="/signup" className="link-underline">Create account</Link></li>
              <li><Link to="/order" className="link-underline">Project brief</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="page-container py-5 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between text-xs text-white/40">
          <span>© {new Date().getFullYear()} Craftora Studio.</span>
          <span>Strategy · Design · Engineering</span>
        </div>
      </div>
    </footer>
  );
}
